module.exports = __webpack_public_path__ + "img/camping-food-cooking.49c7b627.svg";